import React, { useState } from 'react';
import { clsx } from 'clsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Button } from 'src/components/ui/button';
import { useLoader } from 'src/provider/LoaderProvider';

const ReportPdfBtn = ({ statRef }) => {
  const [loading, setLoading] = useState(false);
  const loader = useLoader();

  const handleDownloadPdf = async () => {
    if (!statRef.current) return;

    const headerEl = statRef.current.querySelector('.pdf-header');
    const analyticHeaderEl = statRef.current.querySelector('.analytic-header');

    const wasHidden = headerEl?.classList.contains('hidden');

    try {
      loader.show();
      setLoading(true);

      if (headerEl && wasHidden) {
        headerEl.classList.remove('hidden');
        headerEl.classList.add('flex');
        analyticHeaderEl.classList.add('absolute');
        analyticHeaderEl.classList.add('top-0');
        analyticHeaderEl.classList.add('left-0');
      }

      const canvas = await html2canvas(statRef.current, {
        scale: 2,
        ignoreElements: (el) => {
          return (
            el.classList.contains('analytic-header') ||
            el.classList.contains('analytic-popup-icon') ||
            el.classList.contains('info-tooltip-icon')
          );
        },
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      // Small page padding
      const padding = 10;
      const availableWidth = pageWidth - padding * 2;
      const availableHeight = pageHeight - padding * 2;
      const imgProps = pdf.getImageProperties(imgData);
      // Calculate image ratio
      const imgRatio = imgProps.width / imgProps.height;
      const pageRatio = availableWidth / availableHeight;
      let renderWidth;
      let renderHeight;
      // Fit image inside A4 while preserving aspect ratio
      if (imgRatio > pageRatio) {
        // Image is wider
        renderWidth = availableWidth;
        renderHeight = availableWidth / imgRatio;
      } else {
        // Image is taller
        renderHeight = availableHeight;
        renderWidth = availableHeight * imgRatio;
      }
      // Center image on page
      const x = (pageWidth - renderWidth) / 2;
      pdf.addImage(imgData, 'PNG', x, 0, renderWidth, renderHeight);
      pdf.save('analytics.pdf');
    } finally {
      if (headerEl && wasHidden) {
        headerEl.classList.remove('flex');
        headerEl.classList.add('hidden');
        analyticHeaderEl.classList.remove('absolute');
        analyticHeaderEl.classList.remove('top-0');
        analyticHeaderEl.classList.remove('left-0');
      }
      setLoading(false);
      loader.hide();
    }
  };

  return (
    <Button
      variant="outline"
      className={clsx(loading && 'pointer-events-none opacity-50', 'flex gap-2 report-btn')}
      onClick={handleDownloadPdf}
      disabled={loading}
    >
      <p className="font-medium text-base-xs"> Download report</p>
      <svg
        width="14"
        height="16"
        viewBox="0 0 14 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.55555 1.60001L9.33332 1.60001V4.8L12.4444 4.8L12.4444 14.4L1.55555 14.4L1.55555 1.60001ZM0.776999 6.44724e-06C0.675305 -0.000414529 0.574527 0.0197844 0.480428 0.0594486C0.386328 0.0991127 0.300751 0.157464 0.22859 0.231167C0.156429 0.304871 0.0990979 0.39248 0.0598748 0.488987C0.0206517 0.585494 0.000305793 0.689006 0 0.793606L0 15.2064C0.00162917 15.4165 0.0835471 15.6175 0.228058 15.766C0.372568 15.9145 0.568071 15.9985 0.772332 16H13.2276C13.3298 15.9993 13.4309 15.9778 13.5251 15.9369C13.6192 15.896 13.7046 15.8363 13.7763 15.7614C13.848 15.6866 13.9047 15.5979 13.9431 15.5004C13.9815 15.403 14.0008 15.2987 14 15.1936L14 4.00001L10.1111 6.44724e-06L0.776999 6.44724e-06ZM5.83254 4.4C5.83254 5.6616 5.47866 7.1496 4.88055 8.5224C4.2801 9.9008 3.46966 11.08 2.625 11.7752L3.54277 13.0656C5.81932 11.504 8.3401 10.4336 10.7792 10.792L11.1346 9.2408C9.05643 8.5288 7.38888 6.392 7.38888 4.4H5.83254ZM6.29921 9.1776C6.50765 8.7 6.69199 8.2048 6.84754 7.7032C7.21913 8.28641 7.66544 8.81544 8.17443 9.276C7.41065 9.4168 6.66243 9.648 5.93832 9.9424C6.06692 9.6912 6.18747 9.43627 6.29999 9.1776"
          fill="#05050D"
          fillOpacity="0.8"
        />
      </svg>
    </Button>
  );
};

export default ReportPdfBtn;
